import { createActions, handleActions } from 'redux-actions';

export const types = {
  SUBSCRIBE_CHANNEL: 'SUBSCRIBE_CHANNEL',
  UNSUBSCRIBE_CHANNEL: 'UNSUBSCRIBE_CHANNEL',
};

export const { subscribeChannel, unsubscribeChannel } = createActions({
  [types.SUBSCRIBE_CHANNEL]: (channelName, userID) => ({
    userID,
    channelName,
  }),
  [types.UNSUBSCRIBE_CHANNEL]: (channelName) => ({
    channelName,
  }),
});

const INIT_STATE = {};

const reducer = handleActions(
  {
    [types.SUBSCRIBE_CHANNEL]: (state) => ({
      ...state,
    }),
    [types.UNSUBSCRIBE_CHANNEL]: (state) => ({
      ...state,
    }),
  },
  INIT_STATE
);

export default reducer;



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/pubnub.js